import { defineStore } from 'pinia';
import { ClientJS } from 'clientjs';

export const useUtilsStore = defineStore({
    id: 'utils',
    state: () => ({
        
    }),
    actions: {
        getDeviceDetail(){
            var utilClient = new ClientJS();
            var detectDevice = "";
            if (detectDevice === null || detectDevice === undefined || detectDevice === '') {
                try {
                    detectDevice = '';
                    detectDevice += 'fingerprint:' + utilClient.getFingerprint();
                    var deviceBrowser = utilClient.getBrowser();
                    deviceBrowser = (deviceBrowser === 'Chrome' && utilClient.getUserAgentLowerCase().indexOf("coc_coc") >= 0) ? 'Coccoc' : deviceBrowser;
                    detectDevice += ';devicebrowser:' + deviceBrowser;
                    detectDevice += ';OS:' + (utilClient.getOS() + '-' + utilClient.getOSVersion());
                    var device = utilClient.getDevice();
                    device = device === undefined ? 'PC' : device;
                    detectDevice += ';device:' + device;
                    var deviceType = utilClient.getDeviceType();
                    deviceType = deviceType === undefined ? 'PC' : deviceType;
                    detectDevice += ';devicetype:' + deviceType;
                    detectDevice += ';resolution:' + utilClient.getCurrentResolution();
                }
                catch (err) {
                    console.log(err.message);
                    return "";
                }
            }
        
            return detectDevice;
        },
        async getIPAddress() {
            const res = await fetch(`${process.env.VUE_APP_GATEWAYAPIS_URL}v1.0/get-client-ip`);
            const data = await res.json();
            return data.ip;
          },
        async getLocation() {
            const res = await fetch("http://geoplugin.net/json.gp");
            const data = await res.json();
            return `${data.geoplugin_city} - ${data.geoplugin_countryName}`;
        },
        redirectWithParams(baseUrl, newParams = {}) {
            // Tạo đối tượng URL từ baseUrl
            const url = new URL(baseUrl);
        
            // Duyệt qua các tham số mới cần thêm/cập nhật
            Object.keys(newParams).forEach(key => {
                url.searchParams.set(key, newParams[key]); // Thêm hoặc cập nhật tham số
            });
        
            // Redirect tới URL đã xử lý
            window.location.replace(url.toString());
        }
    }
});